import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Megaphone, FileText, Smartphone, BarChart3, Image } from 'lucide-react';

const MarketingView = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Marketing Studio</h2>
          <p className="text-gray-500">Create marketing assets to promote your social impact</p>
        </div>
      </div>
      
      <div className="bg-white rounded-2xl p-8 shadow-sm border text-center">
        <div className="w-20 h-20 rounded-full bg-purple-100 flex items-center justify-center mx-auto mb-4">
          <Megaphone className="w-10 h-10 text-purple-600" />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">PR & Marketing Tools</h3>
        <p className="text-gray-500 mb-6 max-w-md mx-auto">
          Generate press releases, social media posts, impact reports, and marketing materials powered by AI.
        </p>
        <button
          onClick={() => navigate('/marketing')}
          className="px-6 py-3 bg-purple-600 text-white rounded-xl font-semibold hover:bg-purple-700 transition-all"
        >
          Open Marketing Studio →
        </button>
      </div>
      
      {/* Marketing Tools Preview */}
      <div className="grid grid-cols-2 gap-4 mt-6">
        <div className="bg-white rounded-xl p-5 shadow-sm border hover:shadow-md transition-all cursor-pointer" onClick={() => navigate('/marketing')}>
          <div className="flex items-center gap-3 mb-2">
            <FileText className="w-6 h-6 text-gray-600" />
            <h4 className="font-semibold text-gray-900">Press Releases</h4>
          </div>
          <p className="text-sm text-gray-500">Generate professional press releases about your CSR initiatives</p>
        </div>
        <div className="bg-white rounded-xl p-5 shadow-sm border hover:shadow-md transition-all cursor-pointer" onClick={() => navigate('/marketing')}>
          <div className="flex items-center gap-3 mb-2">
            <Smartphone className="w-6 h-6 text-gray-600" />
            <h4 className="font-semibold text-gray-900">Social Media</h4>
          </div>
          <p className="text-sm text-gray-500">Create engaging social posts for LinkedIn, Twitter, and more</p>
        </div>
        <div className="bg-white rounded-xl p-5 shadow-sm border hover:shadow-md transition-all cursor-pointer" onClick={() => navigate('/marketing')}>
          <div className="flex items-center gap-3 mb-2">
            <BarChart3 className="w-6 h-6 text-gray-600" />
            <h4 className="font-semibold text-gray-900">Impact Reports</h4>
          </div>
          <p className="text-sm text-gray-500">Generate comprehensive ESG and impact reports</p>
        </div>
        <div className="bg-white rounded-xl p-5 shadow-sm border hover:shadow-md transition-all cursor-pointer" onClick={() => navigate('/marketing')}>
          <div className="flex items-center gap-3 mb-2">
            <Image className="w-6 h-6 text-gray-600" />
            <h4 className="font-semibold text-gray-900">Visual Assets</h4>
          </div>
          <p className="text-sm text-gray-500">Create shareable graphics and templates</p>
        </div>
      </div>
    </div>
  );
};

export default MarketingView;
